import { useAppSelector } from 'src/app/store/hooks';

interface OrganizationCellProps {
  organizationId: string;
}

export function OrganizationCell({ organizationId }: OrganizationCellProps) {
  // Extract organization object from the profile since we don't have a direct way to fetch the organization object
  const org = useAppSelector(
    (state) =>
      state.auth.profile?.memberships.find(
        (m) => m.organization.id === organizationId
      )?.organization
  );

  if (!org) {
    return <div>Organization missing from profile</div>;
  }

  return <div>{org.name}</div>;
}
